module.exports = __webpack_public_path__ + "img/img_nshop.deec2bf2.png";